import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { module } from 'modujs'

gsap.registerPlugin(ScrollTrigger)

export default class extends module {
  init() {
    this.cardsWrapper = this.el.querySelector('.job-offers-listing__cards')
    this.cards = [...this.el.querySelectorAll('.job-offers-card')]

    this.filtersWrapperEl = this.el.querySelector('.filter-btn')

    if (this.filtersWrapperEl) {
      this.mm = gsap.matchMedia()

      this.mm.add('(width <= 1000px)', () => {
        ScrollTrigger.create({
          trigger: this.filtersWrapperEl,
          start: 'top 10%',
          endTrigger: this.cardsWrapper,
          end: 'bottom top+=20%',
          pin: true,
          onEnter: () => {
            this.filtersWrapperEl.classList.add('pinned')
          },
          onEnterBack: () => {
            this.filtersWrapperEl.classList.add('pinned')
          },
          onLeaveBack: () => {
            this.filtersWrapperEl.classList.remove('pinned')
            this.filtersWrapperEl.$module?.closeFilters()
          },
          onLeave: () => {
            this.filtersWrapperEl.$module?.closeFilters()
          }
        })
      })
    }
  }

  filter(tagID = 'all') {
    const filteredCards = this.cards.filter((card) => {
      if (tagID === 'all')
        return true

      const tags = card.dataset.tags?.split(',')

      return tags?.includes(tagID)
    })

    this.call(
      'scrollTo',
      '.job-offers-listing',
      'Scroll'
    )

    const tl = gsap.timeline({ onComplete: () => {
      this.call('onFinishedFiltering', 'FilterBtn')
    } })

    tl.to(this.cards, {
      opacity: 0,
      duration: 0.2,
      scale: 0.9,
      ease: 'power4.in',
      display: 'none',
      clearProps: 'opacity,scale'
    })
      .call(() => {
        this.cards.forEach(card => card.classList.remove('filtered', 'active'))

        if (tagID !== 'all') {
          filteredCards.forEach(card => card.classList.add('filtered'))
        }

        this.cardsWrapper.classList.toggle('is-filtered', tagID !== 'all')
      })
      .fromTo(
        filteredCards,
        {
          opacity: 0,
          scale: 1.1,
          display: 'none'
        },
        {
          opacity: 1,
          scale: 1,
          duration: 0.4,
          ease: 'power4.out',
          display: 'flex',
          stagger: { amount: 0.4 },
          delay: 0.2,
          immediateRender: false,
          clearProps: 'opacity,scale'
        }
      )
  }

  destroy() {
    this.mm?.revert()
  }
}
